/******************************************************************************
 *
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria' <Rahul@wakencode.com>, September 2023
 *
 *****************************************************************************/

import SAIcon from "../../assets/images/SAHorizontal.png";
import { Image } from "../image";
import { memo } from "react";

export const HeaderContent = memo(() => {
  return (
    <>
      <Image preview={false} width={300} src={SAIcon} />
    </>
  );
});
